// Set the base path to the folder you copied Shoelace's assets to
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path.js';
setBasePath('@shoelace-style/shoelace/dist/');

// import each Shoelace component
import "@shoelace-style/shoelace/dist/components/card/card.js";
import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/icon-button/icon-button.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/radio-group/radio-group.js';
import '@shoelace-style/shoelace/dist/components/radio/radio.js';
import '@shoelace-style/shoelace/dist/components/radio-button/radio-button.js';
import '@shoelace-style/shoelace/dist/components/checkbox/checkbox.js';
import '@shoelace-style/shoelace/dist/components/textarea/textarea.js';
import '@shoelace-style/shoelace/dist/components/details/details.js';
import '@shoelace-style/shoelace/dist/components/dialog/dialog.js';
import '@shoelace-style/shoelace/dist/components/carousel/carousel.js';


import { registerIconLibrary } from '@shoelace-style/shoelace/dist/utilities/icon-library';

// Self-hosted icons: bundled + content-hashed by Parcel so there is no runtime
// dependency on a third-party CDN. Unknown names fall back to a pinned CDN
// version (never @latest) so nothing silently breaks if a new icon is added.
import biChatLeftDots from 'url:./vendor-icons/bootstrap/chat-left-dots.svg';
import biExclamationCircle from 'url:./vendor-icons/bootstrap/exclamation-circle.svg';
import biShare from 'url:./vendor-icons/bootstrap/share.svg';
import biArrowRepeat from 'url:./vendor-icons/bootstrap/arrow-repeat.svg';

import miEventAvailable from 'url:./vendor-icons/material/event_available.svg';
import miHealthAndSafety from 'url:./vendor-icons/material/health_and_safety.svg';
import miMedication from 'url:./vendor-icons/material/medication.svg';

const bootstrapIcons = {
  'chat-left-dots': biChatLeftDots,
  'exclamation-circle': biExclamationCircle,
  'share': biShare,
  'arrow-repeat': biArrowRepeat
};

const materialIcons = {
  'event_available': miEventAvailable,
  'health_and_safety': miHealthAndSafety,
  'medication': miMedication
};

registerIconLibrary('default', {
  resolver: name => bootstrapIcons[name] ?? `https://cdn.jsdelivr.net/npm/bootstrap-icons@1.13.1/icons/${name}.svg`
});

registerIconLibrary('material', {
  resolver: name => {
    if (materialIcons[name]) return materialIcons[name];
    const match = name.match(/^(.*?)(_(round|sharp))?$/);
    return `https://cdn.jsdelivr.net/npm/@material-icons/svg@1.0.33/svg/${match[1]}/${match[3] || 'outline'}.svg`;
  },
  mutator: svg => svg.setAttribute('fill', 'currentColor')
});
